import { GlobalAxios } from "./../axios/axios-config";
import {
  INewUBusRelationshipGroupItem,
  IUBusRelationshipGroupItem,
} from "../models/u-bus-relationship-group-item";

const ENTITY_ROUTE =
  process.env.REACT_APP_MAIN + "/api/v1/4uBusRelationshipGroupItem/";

export const createUBusRelationshipGroupItem = (
  item: INewUBusRelationshipGroupItem,
) => {
  return GlobalAxios.post(ENTITY_ROUTE, item);
};

export const getUBusRelationshipGroupItemById = (id: string) => {
  return GlobalAxios.get<IUBusRelationshipGroupItem>(ENTITY_ROUTE + id);
};

export const updateUBusRelationshipGroupItemById = ({
  item,
  id,
}: {
  item: INewUBusRelationshipGroupItem;
  id: string;
}) => {
  return GlobalAxios.put(ENTITY_ROUTE + id, item);
};
